import { Component, OnInit } from '@angular/core';
import { LoadingService, LoadingState } from '@app/core/services/loading.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss']
})
export class LoadingModalComponent implements OnInit {
  loading$!: Observable<LoadingState>;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.loading$ = this.loadingService.loading$;
  }
}
